export const isChromeBrowser = (userAgent?: string): boolean => {
  if (typeof navigator === 'undefined' && !userAgent) return true;
  const ua = userAgent ?? navigator.userAgent ?? '';
  const isChromium = ua.includes('Chrome') || ua.includes('CriOS');
  const isEdge = ua.includes('Edg');
  const isOpera = ua.includes('OPR');
  const isBrave = ua.includes('Brave');
  return isChromium && !isEdge && !isOpera && !isBrave;
};